module.exports = __webpack_public_path__ + "media/images/lgt/gallery1-82d6407bbbb28f6c7e1974109c364df0.jpg";